var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSmile = function SvgSmile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8 4a4 4 0 1 0 0 8 4 4 0 0 0 0-8M3 8a5 5 0 1 1 10 0A5 5 0 0 1 3 8m3.071-1.786a.5.5 0 0 1 .5.5v.643a.5.5 0 1 1-1 0v-.643a.5.5 0 0 1 .5-.5m3.858 0a.5.5 0 0 1 .5.5v.643a.5.5 0 0 1-1 0v-.643a.5.5 0 0 1 .5-.5M5.892 8.82a.5.5 0 0 1 .646.288c.087.224.228.424.411.58a1.645 1.645 0 0 0 2.094.015c.187-.153.332-.35.422-.575a.5.5 0 0 1 .927.374c-.152.38-.398.714-.714.974l-.002.002a2.645 2.645 0 0 1-3.37-.025l-.003-.002a2.44 2.44 0 0 1-.698-.985.5.5 0 0 1 .287-.646",
    clipRule: "evenodd"
  })));
};
export { SvgSmile as ReactComponent };
export default __webpack_public_path__ + "f5e0006c00587a9551502031238e6e2b.svg";